import { useState, useEffect, useRef } from "react";

import { useStepContext } from "../utils/StepContext.jsx"
import { useFormContext } from "../utils/FormContext.jsx"
import { useMediaQuery } from 'react-responsive';
import { useAuth } from '../utils/AuthContext/AuthContext.jsx';

import MainCard from "./MainCard.jsx";
import ProgressBar from "./ProgressBar/ProgressBar.jsx";
import InfoModal from "./InfoModal.jsx";

import InfoSVG from "../assets/InfoSVG.jsx"; 
import SaveButton from "./SaveButton.jsx";
import PDFPreview from "./PDFPreview.jsx";
import HelpButton from "./HelpButton.jsx";
import ShishitoAssist from "./ShishitoAssist/ShishitoAssist.jsx";

import DeleteSVG from "../assets/Delete.jsx";
import AddSVG from "../assets/Add.jsx";

const TenantsCard = () => {

    const currentPageValue = 0;
    const currentSubStepProgress = 3/5; 

    const { handleNext, handleBack } = useStepContext();
    const { formData, handleTenantInputChange, handleAddtlTenantChange, handleTenantTypeChange, handleRemoveTenant, handleAddTenant, handleLoanTypeOtherInputChange, formId } = useFormContext(); 
    const [isModalOpen, setIsModalOpen] = useState(false); 
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const gap = 8; 
    const { token, user } = useAuth(); // Use user and token from context
    const [isAssistVisible, setIsAssistVisible] = useState(false);

    const [ tenants, setTenants ] = useState([]);

    // Sync tenants from formData when it updates
        useEffect(() => {
            setTenants(formData.tenants);
        }, [formData.tenants]);

    const handleModalOpen = () => {
        setIsModalOpen(true);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
    };

    const handleAddTenantClick = () => {
        handleAddTenant();
    };
    
    const handleRemoveTenantClick = (index) => {
        handleRemoveTenant(index);
    };

    const onNext = () => {
        handleNext();
    };

    const toggleAssist = () => {
        setIsAssistVisible(!isAssistVisible);
    };

    // console.log("TenantsCard Rendered", formData);

    return (
        <div className="w-full flex flex-col items-center">
        {/* <ProgressBar currentPage={currentPageValue} subStepProgress={currentSubStepProgress}/> */}
        <div className="h-full justify-start items-center flex flex-col">
        <MainCard width={750} maxHeight={450} gap={0}>
        <div className="overflow-y-auto md:max-h-[425px] max-h-[45vh] w-full mb-2 md:mb-4">

                    <div className='inline-flex justify-between items-center w-full mb-5'>
                        {isMobile ? <h3 className="text-black text-[18px] text-left font-normal font-['Inter']">Add tenants?</h3> : <h3 className="text-black text-xl text-left font-normal font-['Inter']">Buying with anyone else?</h3>}
                        <div className='h-auto gap-2 md:gap-4 items-center inline-flex'>
                            <HelpButton onClick={toggleAssist}/>
                            <SaveButton formData={formData} formId={formId}/>
                            {user && <PDFPreview formData={formData}/>}
                        </div>
                    </div>
            <div className="justify-start gap-[25px] inline-flex items-start">
                <div className="items-center gap-2 flex">
                    <input 
                        type="radio" 
                        id="additionalTenantYes"
                        value="yes" 
                        checked={formData.additionalTenants === 'yes'} 
                        onChange={(e) => handleAddtlTenantChange('additionalTenants', e.target.value)}
                    />
                    <label className="text-black font-['Inter']">Yes</label>
                </div>
                <div className="items-center gap-2 flex">
                    <input 
                        type="radio" 
                        id="addtionalTenantNo"
                        value="no" 
                        checked={formData.additionalTenants === 'no'} 
                        onChange={(e) => handleAddtlTenantChange('additionalTenants', e.target.value)}
                    />
                    <label className="text-black font-['Inter']">No</label>
                </div>
                <InfoSVG onClick={handleModalOpen} width={20} height={20}/>
            </div>

            {formData.additionalTenants === 'yes' && (            
            <div className={`${isMobile ? "flex flex-col" : "inline-flex items-center"} w-full self-stretch justify-between gap-[8px] md:gap-[20px] mt-3`}>
                <div className="items-center gap-2 flex">
                    <input 
                        type="checkbox" 
                        id="tenantTypeJoint"
                        value="joint" 
                        checked={formData.tenantType['joint'] || false}
                        onChange={(e) => handleTenantTypeChange('tenantType', e.target.value)}
                    />
                    <label className="text-black text-[12px] md:text-[15px] font-['Inter']">Joint Tenants</label>
                </div>
                <div className="items-center gap-2 flex">
                    <input 
                        type="checkbox" 
                        id="tenantTypeCommon"
                        value="common" 
                        checked={formData.tenantType['common'] || false}
                        onChange={(e) => handleTenantTypeChange('tenantType', e.target.value)}
                    />
                    <label className="text-black text-[12px] md:text-[15px] font-['Inter']">Tenants in Common</label>
                </div>

                <div className={`${isMobile ? "inline-flex w-[330px] gap-[10px]" : "inline-flex gap-[10px]"}`}>
                    <div className="items-center text-[12px] md:text-[16px] gap-2 flex">
                        <input 
                            type="checkbox" 
                            id="tenantTypeOther"
                            value="other" 
                            checked={formData.tenantType['other'] || false}
                            onChange={(e) => handleTenantTypeChange('tenantType', e.target.value)}
                        />
                        <label className="text-black font-['Inter'] md:text-[15px]">Other</label>
                    </div>
                    <div className="w-full h-[39px] justify-between items-center flex mb-2">
                        <input 
                            className={`py-1 px-3 h-[39px] rounded-md border border-slate-300`} 
                            type="text"
                            name="tenantTypeOtherText"
                            placeholder=""
                            value={formData.tenantTypeOtherText}
                            onChange={handleLoanTypeOtherInputChange}
                        />
                    </div>
                </div>
            </div>
            )}


             {/* ADDITIONAL TENANTS */}

             {formData.tenants.map((tenant, index) => (
                <div key={index} className="w-full h-auto justify-between items-start flex flex-col mt-3">
                    <div className="inline-flex justify-between w-full mb-2">
                        <span className='text-sm text-slate-600 mb-1'>
                            Buyer {index + 2} Name
                        </span>
                        {isMobile ? 
                            <DeleteSVG 
                            onClick={() => handleRemoveTenantClick(index)}
                            width="18px" height="18px" />
                            :
                            <DeleteSVG 
                            onClick={() => handleRemoveTenantClick(index)}
                            width="24px" height="24px" />
                        }
                    </div>
                    <div className="w-full h-[39px] justify-between gap-5 items-center flex mb-2">
                            <input
                                type="text"
                                placeholder="First Name *"
                                value={tenant.tenantFirstName}
                                // className={`py-1 px-3 h-[39px] rounded-md border ${errors.tenantFirstName ? 'border-red-500 bg-red-100' : 'border-slate-300'} border-slate-300 w-full`}
                                className={`py-1 px-3 h-[39px] rounded-md border border-slate-300 w-full`}
                                onChange={e => handleTenantInputChange(index, 'tenantFirstName', e.target.value)}
                                // required={formData.additionalTenants === 'yes'}
                                // ref={tenantFirstNameRef}
                            />
                            <input
                                type="text"
                                placeholder="Last Name *"
                                value={tenant.tenantLastName}
                                // className={`py-1 px-3 h-[39px] rounded-md border ${errors.tenantLastName ? 'border-red-500 bg-red-100' : 'border-slate-300'} border-slate-300 w-full`}
                                className={`py-1 px-3 h-[39px] rounded-md border border-slate-300 w-full`}
                                onChange={e => handleTenantInputChange(index, 'tenantLastName', e.target.value)}
                                // required={formData.additionalTenants === 'yes'}
                                // ref={tenantLastNameRef}
                            />
                    </div>
                    <div className="w-full items-center flex flex-col">
                            <div className="w-full justify-between items-start mb-2 flex flex-col">
                                <span className='text-sm text-slate-600 mb-1'>
                                    Buyer {index + 2} Phone
                                </span>
                                <input 
                                    type="text"
                                    placeholder="Phone" 
                                    className={`py-1 px-3 h-[39px] rounded-md border border-slate-300 w-full`} 
                                    value={tenant.tenantPhone}
                                    onChange={e => handleTenantInputChange(index, 'tenantPhone', e.target.value)}
                                >    
                                </input>
                            </div>
                            <div className="w-full justify-between items-start flex flex-col">
                                <span className='text-sm text-slate-600 mb-1'>
                                    Buyer {index + 2}  Email
                                </span>
                                <input 
                                    type="text"
                                    placeholder="Email *" 
                                    // className={`py-1 px-3 h-[39px] rounded-md border ${errors.tenantEmail ? 'border-red-500 bg-red-100' : 'border-slate-300'} border-slate-300 w-full`} 
                                    className={`py-1 px-3 h-[39px] rounded-md border border-slate-300 w-full`} 
                                    value={tenant.tenantEmail}
                                    onChange={e => handleTenantInputChange(index, 'tenantEmail', e.target.value)}
                                    // required={formData.additionalTenants === 'yes'}
                                    // ref={tenantEmailRef}
                                >    
                                </input>
                            </div>
                        </div>
                </div>
            ))}
            </div>
            
            <div className="flex w-full justify-between mt-2 bg-white">
                <button className="w-[100px] md:w-[150px] justify-center text-[16px] md:text-lg text-shi-green bg-white border-white font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-200 items-start flex" onClick={handleBack}>
                    Back
                </button>
                <button onClick={handleAddTenantClick} className="w-[60px] md:w-[150px] items-center justify-center text-center text-shi-green bg-white border-shi-green text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-shi-green hover:text-white md:items-start flex">
                    {isMobile ? <AddSVG width={18} height={18}/> : 'Add Tenant'}
                </button>
                <button className="w-[100px] md:w-[150px] justify-center text-[16px] md:text-lg text-center text-white bg-shi-green  font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-green-950 items-start flex" onClick={onNext}>
                    Next
                </button>
            </div>
        </MainCard>
        {isAssistVisible && (
                <div className="w-full md:w-auto absolute bottom-1 md:right-4">
                    <ShishitoAssist onClose={toggleAssist}/>
                </div>
            )}
        </div>
        
        <InfoModal isOpen={isModalOpen} onClose={handleModalClose}>
                <h1 className="font-inter text-shi-green font-semibold text-xl">Are you purchasing by yourself or with someone else?</h1>
                 <span>If you are purchasing by yourself, then there's nothing to do here. Select "No".</span>

                 <h1 className="font-inter text-shi-green font-semibold text-xl"><br />Joint Tenants</h1>
                 <span>Typically reserved for married couples. Each owner has an equal interest. 50/50 for 2 owners or 1/3 for 3 owners. With joint tenancy, an ownership interest passes to the surviving owners after one owner dies. 
                 The remaining owners will take the deceased owner's interests equally.
                 </span>

                 <h1 className="font-inter text-shi-green font-semibold text-xl"><br />Tenants in Common</h1>
                 <span>Usually reserved for friends or people entering into a business arrangement. Each buyer owns a share of the same property. Buyers jointly determine their percentage of ownership, 
                 which the title should reflect. Co-owners can have an equal share 50/50 or an unequal share say, 70/30.
                 Tenants in common have a right to sell (or convey) their share of ownership as they see fit, even if the other owners disagree.
                 </span>
        </InfoModal>
        </div>
    )
}

export default TenantsCard; 